import React, {useState} from "react";
import {SelectProductsModalProps} from "@feature/quotations/select-products-modal/types";
import Modal from "@ui-components/Modal";
import {FormattedMessage} from "react-intl";
import Button from "@ui-components/Button";
import Placeholder from "@ui-components/Placeholder";
import {QuotationProduct} from "@feature/quotations/quotation-product/quotation-product";
import {Discount} from "@feature/quotations";
import AuthenticationService from "@services/AuthenticationService";

export const SelectProductsModal = ({
  title,
  products,
  onConfirm,
  onClose
}: SelectProductsModalProps) => {

  // state
  const [selected, setSelected] = useState<Set<string>>(new Set());

  // utilities
  const emptyProducts = Object.keys(products).length === 0;
  const allSelected = Object.keys(products).every((p) => selected.has(p));
  const selectAll = () => {
    const newSelected = new Set(Object.keys(products));
    setSelected(newSelected);
  }

  const renderProducts = () => {
    let content;
    if (emptyProducts)
      content = (
        <div className="p-20 flex items-center justify-center text-xl text-gray-200 font-semibold">
          <FormattedMessage id="no_available_products"/>
        </div>
      );
    else
      content = Object.entries(products).filter(([code, p], idx)=>![null, undefined].includes(p.product.prezzo)).map(([code, p], idx) => {
        return <React.Fragment key={idx}>
          <QuotationProduct
            posix={idx}
            editable={false}
            productInfo={p}
            setProductEdits={() => {}}
            productEdits={{
              checked: selected.has(code),
              discount: {type: 'no_discount'} as Discount,  // dummy value, only needed to satisfy the type
              quantity: null,
            }}
            originalProductEdits={{} as any}
            onCheck={() => {
              setSelected((prev) => {
                const newSelected = new Set(prev);
                if (newSelected.has(code)) newSelected.delete(code);
                else newSelected.add(code);
                return newSelected;
              });
            }}
            slim
          />
        </React.Fragment>
      });
    return content;
  }

  return (
    // @ts-ignore
    <Modal onExit={onClose}>
      <div className="flex flex-col gap-4">
        <h1 className="text-center text-xl font-extrabold mt-3">
          {title}
        </h1>
        {!emptyProducts && (
          <div className="flex flex-row items-center justify-between gap-4">
            <p className="font-semibold">
              <FormattedMessage id="select_products" defaultMessage="Seleziona prodotti" />
            </p>
            {/*@ts-ignore*/}
            <Button
              styleType="empty"
              textCls="text-xs"
              onClick={() => {
                if (allSelected) setSelected(new Set());
                else selectAll();
              }}
            >
              {
                allSelected
                  ? <FormattedMessage id="deselect_all" defaultMessage="Deseleziona tutti" />
                  : <FormattedMessage id="select_all" defaultMessage="Seleziona tutti" />
              }
            </Button>
          </div>
        )}
        <div>
          {renderProducts()}
        </div>
        <div>
          {/* @ts-ignore */}
          <Button
            disabled={selected.size === 0}
            onClick={() => { onConfirm(Array.from(selected)); }}
            full
          >
            <FormattedMessage id="proceed" />
          </Button>
        </div>
      </div>
    </Modal>
  );
};
